import { FichaEdificios } from "../../components";
import "./stylesPortafolioFichaEdificios.scss";

export const PortafolioFichaEdificios = () => (
  <div className="body-portafolio">
    <FichaEdificios />
  </div>
);
